import { Button, Modal, ModalContent } from "@blurb/codex-react";
import { Box, createStyles } from "@mantine/core";

const useStyles = createStyles(() => ({
  body: {
    fontSize: "16px",
    lineHeight: "140%",
  },
  buttonGroup: {
    display: "flex",
    gap: "var(--codex-spacing-2)",
    justifyContent: "flex-end",
  },
}));

interface ConfirmCancelModalProps {
  opened: boolean;
  onClose: () => void;
  onConfirm: () => void;
}

export const ConfirmCancelModal: React.FC<ConfirmCancelModalProps> = ({ opened, onClose, onConfirm }) => {
  const { classes } = useStyles();

  return (
    <Modal open={opened}>
      <ModalContent size="small" title="Cancel Create New Product?">
        <Box className={classes.body}>Any unsaved changes will be permanently lost.</Box>

        <Box className={classes.buttonGroup}>
          <Button variant="outlined" intent="neutral" size="small" onClick={onClose}>
            Never Mind
          </Button>
          <Button variant="filled" intent="danger" size="small" onClick={onConfirm}>
            Yes, Cancel
          </Button>
        </Box>
      </ModalContent>
    </Modal>
  );
};
